import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	messageList: {
		url: api("/admin/live_water_army/messageList"),
		name: "水军消息列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	sendMessage: {
		url: api("/admin/live_water_army/sendMessage"),
		name: "发送水军消息",
		post(params) {
			return http.post(this.url, params);
		},
	},
};
